// /frontend/src/pages/dashboard/post/instagram/InstagramOptionsDrawer.js  (v2.0 – modernized UI)
// All logic identical to v1.
import React, { useState } from 'react';

const FORMATS = [
  { key: 'feed',     label: 'Feed Post', icon: 'fas fa-image' },
  { key: 'story',    label: 'Story',     icon: 'fas fa-circle-notch' },
  { key: 'reel',     label: 'Reel',      icon: 'fas fa-film' },
  { key: 'carousel', label: 'Carousel',  icon: 'fas fa-th-large' },
];

export default function InstagramOptionsDrawer ({ instagramAccounts, updateAccountOption, filesCount }) {
  const [open, setOpen] = useState(true);
  if (!instagramAccounts.length) return null;

  const moreThanOne      = filesCount > 1;
  const carouselDisabled = filesCount < 2 || filesCount > 10;

  const getDisabled = key => {
    if (key === 'carousel') return carouselDisabled;
    if (key === 'feed' || key === 'reel') return moreThanOne;
    return false;
  };
  const getTooltip = key => {
    if (key === 'carousel' && carouselDisabled) return 'Select 2–10 media items to enable Carousel.';
    if ((key === 'feed' || key === 'reel') && moreThanOne) return 'Feed/Reel support only a single media item.';
    return '';
  };

  return (
    <div style={{ background:'#ffffff', border:'1px solid #e5e7eb', borderRadius:12, marginBottom:12, overflow:'hidden', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' }}>
      {/* Header */}
      <button
        type='button'
        onClick={() => setOpen(o => !o)}
        style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', background:'transparent', border:'none', cursor:'pointer' }}
      >
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:26, height:26, borderRadius:'50%', background:'#fdf2f8', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            <i className='fab fa-instagram' style={{ fontSize:12, color:'#C32AA3' }} />
          </div>
          <span style={{ fontSize:13, fontWeight:700, color:'#111827' }}>Instagram Options</span>
        </div>
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`} style={{ fontSize:11, color:'#9ca3af' }} />
      </button>

      {/* Body */}
      {open && (
        <div style={{ padding:'4px 16px 16px', borderTop:'1px solid #f3f4f6' }}>
          {instagramAccounts.map(acc => (
            <div key={acc.id} style={{ marginTop:12 }}>
              {instagramAccounts.length > 1 && (
                <div style={{ fontSize:12, fontWeight:600, color:'#6b7280', marginBottom:8 }}>{acc.displayName}</div>
              )}
              <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                {FORMATS.map(fmt => {
                  const disabled  = getDisabled(fmt.key);
                  const isChecked = acc.options?.format === fmt.key;
                  return (
                    <button
                      key={fmt.key}
                      type='button'
                      disabled={disabled}
                      title={getTooltip(fmt.key)}
                      onClick={() => !disabled && updateAccountOption(acc.id, acc.platform, { format: fmt.key, _auto: false })}
                      style={{
                        display    : 'flex',
                        alignItems : 'center',
                        gap        : 6,
                        padding    : '6px 12px',
                        borderRadius: 8,
                        border     : `1.5px solid ${isChecked ? '#C32AA3' : '#e5e7eb'}`,
                        background : isChecked ? '#fdf2f8' : disabled ? '#fafafa' : '#ffffff',
                        color      : isChecked ? '#C32AA3' : disabled ? '#d1d5db' : '#374151',
                        fontSize   : 12,
                        fontWeight : isChecked ? 700 : 500,
                        cursor     : disabled ? 'not-allowed' : 'pointer',
                        transition : 'all 0.15s',
                      }}
                    >
                      <i className={fmt.icon} style={{ fontSize:11 }} />
                      {fmt.label}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}